import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/course');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('course', validationApi);

export function getCourseValidationHistoryOptions(courseId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(courseId);
}

export function getCourseValidationOptions(courseId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(courseId);
}

export function useValidateCourse(courseId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(courseId, queryClient));
}
